<template>
	<v-chip
		v-bind="$attrs"
		:color="color"
		:text-color="textColor"
		x-small
		v-on="$listeners"
	>
		<slot />
	</v-chip>
</template>

<script>
export default {
	inheritAttrs: false,
	props: {
		color: {
			type: String,
			default: null
		},
		textColor: {
			type: String,
			default: null
		}
	}
}
</script>
